import React, { useMemo } from 'react';
import Icon from '../../components/common/Icon/Icon';
import ColorDot from '../../components/common/ColorDot/ColorDot';
import type { ColorDotVariant } from '../../components/common/ColorDot/ColorDot';
import type { FupLink } from '../../types/orchestrator';
import {
  canRemoveFupLink,
  formatFupLinkCreatedDate,
  getFupLinkStatusLabel,
  resolveFupLinkVisualStatus,
  sortFupLinksForDisplay,
} from './fupLinkDisplay';
import styles from './Orchestrator.module.css';

type FupLinkAttemptsListProps = {
  links: FupLink[];
  onRemoveRequest?: (link: FupLink) => void;
};

const FUP_LINK_DOT_VARIANT: Record<string, ColorDotVariant> = {
  waiting: 'waiting',
  expired: 'expired',
  success: 'success',
};

const FupLinkAttemptsList: React.FC<FupLinkAttemptsListProps> = ({ links, onRemoveRequest }) => {
  const sortedLinks = useMemo(() => sortFupLinksForDisplay(links), [links]);

  if (sortedLinks.length === 0) {
    return null;
  }

  return (
    <div className={styles['fup-link-attempts']} aria-label="Tentativas de link de FUP">
      {sortedLinks.map((link) => {
        const status = resolveFupLinkVisualStatus(link);
        const statusLabel = getFupLinkStatusLabel(status);
        const showRemove = canRemoveFupLink(link);

        return (
          <div
            key={link.token}
            className={styles['fup-link-attempt']}
            title={`Tentativa ${link.attempt_number}: ${statusLabel}`}
          >
            <ColorDot
              variant={FUP_LINK_DOT_VARIANT[status] ?? 'waiting'}
              aria-label={statusLabel}
              title={`Tentativa ${link.attempt_number}: ${statusLabel}`}
            />
            <span className={styles['fup-link-attempt-date']}>
              {formatFupLinkCreatedDate(link.created_at)}
            </span>
            {showRemove && onRemoveRequest && (
              <button
                type="button"
                className={styles['fup-link-remove-btn']}
                aria-label={`Remover link de FUP de ${formatFupLinkCreatedDate(link.created_at)}`}
                onClick={() => onRemoveRequest(link)}
              >
                <Icon name="delete" size={16} color="var(--color-solid-danger)" />
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default FupLinkAttemptsList;
